import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import BgImg from "../../images/services-usa/game_update/get_app_bg.webp";
import {StaticImage} from "gatsby-plugin-image";

function GetApp(props) {
    return (
        <section className="gat_game_app p-100"   style={{backgroundImage: `url(${BgImg})`}}>
            <Container>
                <Row>
                    <Col xxl={10} xl={10} lg={12} className="m-auto text-center">
                        <h2>Why Get a Game App For <br/>Your Business?</h2>
                        <p>The mobile game market is expected to exhibit a compound annual growth rate (CAGR 2023-2027) of 7.43%, resulting in a projected market volume of US$118.90bn by 2027.</p>
                        <p>This makes it the best time for you to enter into this business. Now, whether you're trying to introduce a new game or trying to gamify your already existing business, here's how a game app can redefine your business strategy:</p>
                    </Col>
                </Row>
                <Row>
                    <Col xxl={3} xl={3} lg={4} >
                        <div className="gat_app_txt">
                            <h5><span>01</span>Boost Customer Engagement</h5>
                            <p>A game app is a fun and interactive way to keep your audience engaged with your brand.</p>
                        </div>
                        <div className="gat_app_txt">
                            <h5><span>02</span>Increase Brand Loyalty</h5>
                            <p>When customers enjoy playing your game, they feel a connection to your brand which forces them to come back for more.</p>
                        </div>
                        <div className="gat_app_txt">
                            <h5><span>03</span>Interactive Marketing</h5>
                            <p>A game app is a new way of interacting with customers by letting them experience it firsthand through the game.</p>
                        </div>
                    </Col>
                    <Col xxl={6} xl={6} lg={4} >
                        <div className="gat_img">
                            <StaticImage
                                src="../../images/services-usa/game_update/get_app_img.webp"
                                alt="get_app_img"
                                className="img-fluid"
                                layout="constrained"
                                placeholder="blurred"
                                formats={["webp"]}
                                width={792}
                                height={610}
                            />
                        </div>
                    </Col>
                    <Col xxl={3} xl={3} lg={4} >
                        <div className="gat_app_txt">
                            <h5><span>04</span>Make Learning Fun</h5>
                            <p>Teaching through playful content engages audiences, making learning feel like fun rather than a tedious task to complete.</p>
                        </div>
                        <div className="gat_app_txt">
                            <h5><span>05</span>Boost Sales and Revenue</h5>
                            <p>Game apps elevate sales with in-app purchases, ads, and premium features, paving the way for diversified revenue streams.</p>
                        </div>
                        <div className="gat_app_txt">
                            <h5><span>06</span>Improved User Experience</h5>
                            <p>With an app, you can offer a smoother and more user-friendly interaction, which can enhance the reputation of your brand.</p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default GetApp;